module.exports = __webpack_public_path__ + "img/icon3.c2cb2f53.png";